import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
// import SideNav from "./SideNav";

const CreditCard = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [bank, setBank] = useState("");
  const [dueBill, setDueBill] = useState(null);
  const [showTracker, setShowTracker] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    if (cardNumber.length === 16 && bank) {
      fetchDueBill(cardNumber, bank);
    }
  }, [cardNumber, bank]);

  const fetchDueBill = async (card, selectedBank) => {
    try {
      const response = await fetch("https://your-api-url.com/fetch-bill", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ card, bank: selectedBank }),
      });

      const data = await response.json();
      setDueBill(data?.billAmount || "No due found");
    } catch (error) {
      console.error("API error:", error);
      setDueBill("Error fetching bill");
    }
  };

  return (
    <>
      <Navbar />
      <div className="radial-bg"></div>
      <section className="insurance-service position-relative overflow-hidden">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3  d-none d-lg-block">
              <div style={{ position: "relative", height: "100%" }}>
                <SideNav />
              </div>
            </div> */}
            <div className="col-12">
              <div
                className="row justify-content-center text-center"
              >
                <div className="col-12">
                  <h2 className="fw-semibold recharge-title">Credit Card</h2>
                </div>
              </div>

              <div className="row justify-content-center align-items-center">
                <div className="col-12 col-md-8 col-lg-6">
                  <div className="card p-4 shadow mb-5 recharge-box mt-5">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Enter 16 Digit Credit Card Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="XXXX XXXX XXXX 1234"
                        maxLength="16"
                        value={cardNumber}
                        onInput={(e) => {
                          const onlyNums = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 16);
                          setCardNumber(onlyNums);
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Choose Bank
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        list="bankList"
                        placeholder="Select Bank"
                        value={bank}
                        onChange={(e) => setBank(e.target.value)}
                      />
                      <datalist id="bankList">
                        <option value="State Bank" />
                        <option value="Axis Bank" />
                        <option value="HDFC Bank" />
                        <option value="RBL Bank" />
                        <option value="BOB Bank" />
                        <option value="IDFC Bank" />
                      </datalist>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Choose Amount / Full Amount
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your amount"
                      />
                    </div>

                    <div className="d-grid">
                      <button
                        className="btn btn-primary"
                        style={{ fontFamily: "poppins" }}
                      >
                        Processed
                      </button>
                    </div>

                    <div className="mt-3" style={{ fontFamily: "poppins" }}>
                      <span>Status Pending?</span>
                      <br />
                      <button
                        className="btn btn-link text-decoration-none text-primary fw-semibold d-inline-flex align-items-center gap-1 p-0"
                        onClick={() => setShowTracker(!showTracker)}
                      >
                        Track Your Status now{" "}
                        <i className="bi bi-arrow-right-short fs-5"></i>
                      </button>

                      {showTracker && (
                        <div className="card p-3 mt-2 shadow-sm">
                          <label className="form-label">
                            Credit Card Number / Mobile Number
                          </label>
                          <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Enter Number To Track Your Status"
                          />
                          <button
                            className="btn btn-outline-primary"
                            style={{ fontFamily: "poppins" }}
                          >
                            Track Now
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="position-absolute bottom-0 start-0 end-0"
              style={{
                height: "25rem",
                background: "linear-gradient(to top, #F5F2FF, transparent)",
                zIndex: "-1",
              }}
            />
          </div>
        </div>
      </section>
      <Explore />
      <Footer />
    </>
  );
};

export default CreditCard;
